import { Button } from './Button';

export type ModalProps = {
	onAccept: () => void;
	onReject?: () => void;
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	title: string;
	subtext?: string;
};

export function Modal({ open, setOpen, onAccept, onReject, title = 'Are you sure?', subtext }: ModalProps) {
	return (
		<>
			{open == true ? (
				<dialog
					open={open}
					onKeyDown={(keyPress) => {
						keyPress.preventDefault();
						if (keyPress.key == 'Escape') {
							// onReject?.();
							setOpen(false);
						}
					}}
				>
					<div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm transition-opacity" aria-hidden="true"></div>
					<div className="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
						<div className="fixed inset-0 z-50 w-screen overflow-y-auto">
							<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
								<div className="relative overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
									<div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
										<div className="sm:flex sm:items-start">
											<div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
												<h3 className="text-base font-semibold text-gray-900" id="modal-title">
													{title}
												</h3>
												{!subtext || (
													<div className="mt-2">
														<p className="text-sm text-gray-500">{subtext}</p>
													</div>
												)}
											</div>
										</div>
									</div>
									<div className="gap-3 bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
										<Button
											autoFocus
											onClick={() => {
												onAccept();
												setOpen(false);
											}}
										>
											Yes
										</Button>
										<Button
											onClick={() => {
												onReject?.();
												setOpen(false);
											}}
											mode="inverse"
										>
											No
										</Button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</dialog>
			) : (
				<></>
			)}
		</>
	);
}
